<template>
  <transition name="expand" v-bind="$attrs" v-on="hooks">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  props: {
    duration: {
      type: [String, Number],
      default: "300",
    },
  },
  computed: {
    hooks() {
      return {
        beforeEnter: this.beforeEnter,
        enter: this.enter,
        afterEnter: this.afterEnter,
        beforeLeave: this.beforeLeave,
        leave: this.leave,
        afterLeave: this.afterLeave,
      };
    },
  },
  methods: {
    beforeEnter(element) {
      this.setDuration(element);
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = "0px";
        }

        element.style.display = null;
      });
    },
    enter(element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = `${element.scrollHeight}px`;
        });
      });
    },
    afterEnter(element) {
      this.cleanUpDuration(element);
      element.style.height = null;
    },
    beforeLeave(element) {
      this.setDuration(element);
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = `${element.offsetHeight}px`;
        }
      });
    },
    leave(element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = "0px";
        });
      });
    },
    afterLeave(element) {
      this.cleanUpDuration(element);
    },
    setDuration(el) {
      el.style.transition = `height ${this.duration}ms ease-out`;
    },
    cleanUpDuration(el) {
      el.style.transitionDuration = "";
    },
  },
};
</script>
